import Component from './radio-tabs';
export default Component;
